// extracted by mini-css-extract-plugin
module.exports = {"business_rule_list":"business_rule_list__wQ0uDAIJAsmz+"};